<div class="flex flex-col flex-auto min-w-0">

    <!-- Main -->
    <div class="flex-auto">

        <!-- CONTENT GOES HERE -->
        <div class="h-full max-content-h" *ngIf="isDefault">
            <div class="drk-page-wrapper">
                <kendo-tabstrip (tabSelect)="onTabSelect($event, tab.tabCode)" [keepTabContent]="true">
                    <kendo-tabstrip-tab [title]="tab.tabTitle | transloco" [selected]="selectedTab == tab.tabCode"
                        *ngFor="let tab of pageData?.pageTabs; index as i">
                        <ng-template kendoTabContent>

                            <div class="drk-tab-content" *ngIf="tab.tabMode == 'FRE'">
                                <div class="drk-component-free " *ngFor="let c of tab.tabComponents"
                                    [style.width.%]="c.componentSizeW / 30 * 100" [style.height]="c.componentSizeH > 0 ? (c.componentSizeH / 30 * 100) + '%' : 'auto'"
                                    [style.left.%]="c.componentPositionX / 30 * 100" [style.top]="c.componentPositionY > 0 ? (c.componentPositionY / 30 * 100) + '%' : 'auto'">
                                    <div class="overflow-hidden flex-w-full">
                                        <app-drake-custom-component [config]="c" [baseData]="baseData"
                                            (outputEvent)="onValueChange($event)"
                                            [mainRecord]="mainRecord"></app-drake-custom-component>
                                    </div>
                                </div>
                            </div>
                            <div class="drk-tab-content" *ngIf="!tab.tabMode || tab.tabMode == 'STD'">

                                <kendo-tilelayout  [style.width]="'100%'" [style.height]="'100%'"
                                   [columns]="30" [rowHeight]="'50px'" [gap]="16">
                                    <kendo-tilelayout-item *ngFor="let c of tab.tabComponents" 
                                    [hidden]="c.componentVisible === false"
                                    [col]="c.componentPositionX" [colSpan]="c.componentSizeW"
                                        [row]="c.componentPositionY" [rowSpan]="c.componentSizeH"
                                         [style]="c.componentStyle">

                                        <kendo-tilelayout-item-header *ngIf="c.componentShowHeader">
                                            <div class="flex items-start justify-between" >
                                                <div class="mt-1">
                                                    <h5 class="header-text">
                                                      {{ c.componentName | transloco}}
        
                                                    </h5>
                                                </div>
                                                <div *ngIf="!readonly && (c?.componentDescription | transloco)"><mat-icon [svgIcon]="'heroicons_solid:information-circle'" [title]="c?.componentDescription | transloco"></mat-icon></div>
                                            </div>

                                          </kendo-tilelayout-item-header>
                                        <kendo-tilelayout-item-body>
                                            <app-drake-custom-component [config]="c" [baseData]="baseData"
                                                (outputEvent)="onValueChange($event)"
                                                [mainRecord]="mainRecord" [pageData]="pageData"></app-drake-custom-component>
                                        </kendo-tilelayout-item-body>
                                    </kendo-tilelayout-item>
                                </kendo-tilelayout>
                            </div>
                        </ng-template>
                    </kendo-tabstrip-tab>

                </kendo-tabstrip>
            </div>
        </div>


        <!-- CONTENT GOES HERE -->
        <div class="h-200 min-h-200 max-h-200" *ngIf="!isDefault">
            <div class="drk-page-wrapper">
                <div class="drk-component" *ngFor="let c of pageData?.pageTabs[0]?.tabComponents"
                    [style.width.%]="c.componentSizeW" [style.height.%]="c.componentSizeH"
                    [style.left.%]="c.componentPositionX" [style.top.%]="c.componentPositionY">
                    <div>
                        <app-drake-custom-component
                        [config]="c" [baseData]="baseData"
                            (outputEvent)="onValueChange($event)"
                            [mainRecord]="mainRecord" [pageData]="pageData"></app-drake-custom-component>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>